import { useEffect, useState, useCallback, useContext } from "react";
import { MdDriveEta } from "react-icons/md";
import { StylesValue } from "../contexts/styles";

export default function usePropFormatter(block) {
  const [_props, setProps] = useState(null);

  useEffect(() => {
    const _newProps = {};

    Object.keys(block.props).forEach((k) => {
      if (Array.isArray(block.props[k])) {
        if (!block.props[k][0] && block.props[k][0] !== "") {
          return (_newProps[k] = []);
        }

        _newProps[k] = block.props[k]
          .map((v) => {
            if (typeof v === "string") {
              return v;
            }
            return Object.keys(v)
              .map((k) => {
                return v[k].name;
              })
              .join(" > ");
          })
          .join("");
      } else {
        _newProps[k] = block.props[k];
      }
    });
    setProps(_newProps);
  }, [block.props]);

  return { _props };
}
